import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useBookmarks } from './reader.js';
/**
 * The book's bookmarks as an editable list — jump to one, rename it inline,
 * delete it. Headless like {@link HighlightsPanel}: a plain `<ol>` with
 * `data-pore-bm-*` hooks and no chrome of its own. Renders nothing on a source
 * that can't persist bookmarks.
 */
export function BookmarksPanel({ className, emptyLabel = 'No bookmarks yet — press the bookmark button to add one.', onJump, }) {
    const { bookmarks, supported, goTo, remove, rename } = useBookmarks();
    const [editing, setEditing] = useState(null);
    if (!supported)
        return null;
    if (bookmarks.length === 0) {
        return (_jsx("p", { ...(className ? { className } : {}), "data-pore-bm-empty": true, children: emptyLabel }));
    }
    return (_jsx("ol", { ...(className ? { className } : {}), "data-pore-bm-list": true, children: bookmarks.map((bm) => (_jsxs("li", { "data-pore-bm-item": true, children: [editing === bm.id ? (_jsx("input", { "data-pore-bm-rename": true, "aria-label": "Rename bookmark", defaultValue: bm.label, autoFocus: true, onBlur: (e) => {
                        const v = e.target.value.trim();
                        if (v && v !== bm.label)
                            rename(bm.id, v);
                        setEditing(null);
                    }, onKeyDown: (e) => {
                        if (e.key === 'Enter')
                            e.target.blur();
                        if (e.key === 'Escape')
                            setEditing(null);
                    } })) : (_jsxs("button", { type: "button", "data-pore-bm-jump": true, onClick: () => {
                        goTo(bm);
                        onJump?.(bm);
                    }, onDoubleClick: () => setEditing(bm.id), children: [_jsx("span", { "data-pore-bm-label": true, children: bm.label }), _jsxs("span", { "data-pore-bm-pct": true, children: [Math.round(bm.percent * 100), "%"] })] })), _jsx("button", { type: "button", "data-pore-bm-rename-btn": true, "aria-label": "Rename bookmark", onClick: () => setEditing(bm.id), children: "\u270E" }), _jsx("button", { type: "button", "data-pore-bm-remove": true, "aria-label": "Remove bookmark", onClick: () => remove(bm.id), children: "\u00D7" })] }, bm.id))) }));
}
//# sourceMappingURL=bookmarks-panel.js.map